import { LayoutContainer } from "@relode/core";
import * as React from "react";

import { ClientPublicJobMarketResearch } from "./clientPublicJobMarketResearch";

export const ClientPublicJobInsights = () => (
    <LayoutContainer>
        <ClientPublicJobMarketResearch />
    </LayoutContainer>
);
